export const findScrollableParent = (
  element: HTMLElement,
  threshold: number = 5
) => {
  let current = element,
    counter = 0;

  while (counter++ < threshold) {
    current = current.parentElement!;
    if (current.clientHeight > 0 && current.scrollHeight > current.clientHeight)
      return current;
  }

  throw new Error("");
};

export const isBefore = (element: HTMLElement, container: HTMLElement) =>
  element.getBoundingClientRect().top < container.getBoundingClientRect().top;

export const isAfter = (element: HTMLElement, container: HTMLElement) =>
  element.getBoundingClientRect().bottom >
  container.getBoundingClientRect().bottom;

export const isOutOfView = (element: HTMLElement, container: HTMLElement) =>
  isBefore(element, container) || isAfter(element, container);

export const isWithinView = (element: HTMLElement, container: HTMLElement) =>
  !isOutOfView(element, container);
